module.exports = __webpack_public_path__ + "img/img1.adfb87e3.png";